<ion-content>
  <div class="constrained-content">
    <div
      class="fullscreen-spinner-container"
      style="background: transparent"
      *ngIf="!customer"
    >
      <ion-spinner name="crescent" class="fullscreen-spinner"></ion-spinner>
    </div>

    <ion-grid *ngIf="customer">
      <ion-row>
        <ion-col size="12">
          <div style="padding: 0 10px" class="flex-space-between">
            <app-channel-selector
              [channel]="slackChannel"
              (channelDidChange)="onSlackChannelChanged($event)"
              [defaultExternalOnly]="customer.isInternal ? false : true"
              [defaultInternalOnly]="customer.isInternal ? true : false"
              [hideSecondaryTeams]="false"
            ></app-channel-selector>
            <div style="display: flex"></div>
          </div>
        </ion-col>

        <!-- Ticket Intake Process Visualizer -->
        <ion-col size="12" *ngIf="customer.type === CHANNEL_TYPES.SLACK">
          <ion-card class="outline-card transparent-bg">
            <ion-card-title class="card-title">
              <h3>Ticket Intake Process</h3>
            </ion-card-title>
            <ion-card-content>
              <app-ticket-intake-visualizer
                [config]="ticketIntakeConfig"
                [editable]="true"
                [showSlaDropdown]="true"
                [projectId]="project?.id"
                [projectSupportSteps]="project?.supportSteps || []"
                [customerSupportSteps]="customer?.supportSteps || []"
                (configChange)="onTicketIntakeConfigChange($event)"
              ></app-ticket-intake-visualizer>
            </ion-card-content>
          </ion-card>
        </ion-col>

        <ion-col size="12">
          <ion-card class="outline-card">
            <ion-card-title class="card-title">
              <h3>Conversation Tracking Settings</h3>
            </ion-card-title>
            <ion-list>
              <ion-item *ngIf="customer.type === CHANNEL_TYPES.SLACK">
                <ion-icon
                  name="people-outline"
                  slot="start"
                  style="margin-right: 15px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Enable automated ticketing for agents and teammates</h3>
                  <p>
                    Allow agent and teammate messages to trigger automated
                    ticket creation
                  </p>
                </ion-label>
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="enableAgentAutomatedTicketing"
                  class="select-outline"
                  [compareWith]="genericCompareFn"
                >
                  <ion-select-option [value]="null">
                    Default ({{
                      project?.enableAgentAutomatedTicketing
                        ? "Enabled"
                        : "Disabled"
                    }})
                  </ion-select-option>
                  <ion-select-option [value]="false">
                    Disabled
                  </ion-select-option>
                  <ion-select-option [value]="true">
                    Enabled
                  </ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item>
                <ion-icon
                  name="swap-horizontal-outline"
                  slot="start"
                  style="margin-right: 15px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Override Triage channel</h3>
                  <p>
                    Choose an internal channel to cross-post conversations to.
                    <br />Learn more about
                    <a
                      href="https://docs.unthread.io/conversations/triaging"
                      target="_blank"
                      >triaging</a
                    >
                  </p>
                </ion-label>
                <label class="switch" slot="end">
                  <input type="checkbox" [(ngModel)]="overrideTriage" />
                  <span class="slider"></span>
                </label>
              </ion-item>
              <ng-container *ngIf="overrideTriage">
                <ion-item>
                  <ion-label slot="end">
                    <app-channel-selector
                      [channel]="triageChannel"
                      (channelDidChange)="onTriageChannelChanged($event)"
                      [defaultInternalOnly]="true"
                    ></app-channel-selector>
                  </ion-label>
                </ion-item>
              </ng-container>
              <ng-container *ngIf="getAutomatedTicketingWithDefault()">
                <ion-item *ngIf="customer.type === CHANNEL_TYPES.SLACK">
                  <ion-icon
                    name="apps-outline"
                    slot="start"
                    style="margin-right: 15px"
                  ></ion-icon>
                  <ion-label text-wrap>
                    <h3>Track incoming messages from bots and apps</h3>
                    <p>Bot messages will create tickets</p>
                  </ion-label>
                  <ion-select
                    slot="end"
                    interface="popover"
                    [(ngModel)]="botHandling"
                    class="select-outline"
                    [compareWith]="botHandlingCompareFn"
                  >
                    <ion-select-option [value]="null">
                      Default ({{ botHandlingDefaultLabel() }})
                    </ion-select-option>
                    <ion-select-option value="off">
                      Disabled
                    </ion-select-option>
                    <ion-select-option value="all"> Enabled </ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item *ngIf="customer.type === CHANNEL_TYPES.SLACK">
                  <ion-icon
                    name="timer-outline"
                    slot="start"
                    style="margin-right: 15px"
                  ></ion-icon>
                  <ion-label text-wrap>
                    <h3>
                      Group top-level messages that arrive within time period
                    </h3>
                    <p>
                      This will merge top-level messages into a single ticket
                    </p>
                  </ion-label>
                  <ion-select
                    slot="end"
                    interface="popover"
                    [(ngModel)]="replyTimeoutMinutes"
                    class="select-outline"
                    [compareWith]="replyTimeoutMinutesCompareFn"
                  >
                    <ion-select-option [value]="null">
                      Default ({{ replyTimeoutMinutesDefaultLabel() }})
                    </ion-select-option>
                    <ion-select-option [value]="0"> Never </ion-select-option>
                    <ion-select-option [value]="5">
                      5 minutes
                    </ion-select-option>
                    <ion-select-option [value]="10">
                      10 minutes
                    </ion-select-option>
                    <ion-select-option [value]="15">
                      15 minutes
                    </ion-select-option>
                    <ion-select-option [value]="30">
                      30 minutes
                    </ion-select-option>
                    <ion-select-option [value]="45">
                      45 minutes
                    </ion-select-option>
                    <ion-select-option [value]="60"> 1 hour </ion-select-option>
                    <ion-select-option [value]="120">
                      2 hours
                    </ion-select-option>
                    <ion-select-option [value]="180">
                      3 hours
                    </ion-select-option>
                    <ion-select-option [value]="240">
                      4 hours
                    </ion-select-option>
                    <ion-select-option [value]="300">
                      5 hours
                    </ion-select-option>
                    <ion-select-option [value]="360">
                      6 hours
                    </ion-select-option>
                    <ion-select-option [value]="720">
                      12 hours
                    </ion-select-option>
                    <ion-select-option [value]="1440">
                      24 hours
                    </ion-select-option>
                    <ion-select-option [value]="-1"> Always </ion-select-option>
                  </ion-select>
                </ion-item>

                <ion-item>
                  <ion-icon
                    name="git-branch-outline"
                    slot="start"
                    style="margin-right: 15px"
                  ></ion-icon>
                  <ion-label slot="start" text-wrap>
                    <h3>Conditional conversation tracking</h3>
                    <p>
                      Only track conversations that meet the specified
                      conditions
                    </p>
                  </ion-label>
                  <label class="switch" slot="end">
                    <input
                      type="checkbox"
                      [(ngModel)]="conditionalConversationCreationEnabled"
                      (change)="
                        onConditionalConversationCreationChanged($event)
                      "
                    />
                    <span class="slider"></span>
                  </label>
                </ion-item>

                <ng-container *ngIf="conditionalConversationCreationEnabled">
                  <div style="width: 100%; padding: 0 16px">
                    <ion-list
                      *ngFor="
                        let condition of conversationCreationConditions;
                        let i = index
                      "
                    >
                      <div class="hr-container" *ngIf="i > 0">
                        <hr />
                        <ion-label class="hr-text" style="text-align: center"
                          >or</ion-label
                        >
                        <hr />
                      </div>
                      <div class="hr-container">
                        <ion-label class="hr-text"
                          >Condition {{ i + 1 }}
                          <a
                            (click)="removeConditionalRule(i)"
                            [hidden]="i === 0"
                            >(remove)</a
                          ></ion-label
                        >
                      </div>

                      <div class="inner-padding">
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                          "
                        >
                          <ion-select
                            interface="popover"
                            style="width: 38%"
                            class="select-outline"
                            [(ngModel)]="condition.field"
                            (ionChange)="onConditionChange(condition)"
                          >
                            <ion-select-option
                              *ngFor="let conditionValue of conditionValues()"
                              [value]="conditionValue[0]"
                              >{{ conditionValue[1].label }}</ion-select-option
                            >
                          </ion-select>
                          <ion-select
                            [disabled]="
                              CONDITIONS[condition.field]?.types?.length === 1
                            "
                            interface="popover"
                            style="width: 20%"
                            class="select-outline"
                            [(ngModel)]="condition.operator"
                          >
                            <ion-select-option
                              *ngFor="
                                let conditionType of CONDITIONS[condition.field]
                                  ?.types
                              "
                              [value]="conditionType"
                              >{{
                                CONDITION_TYPE_LABELS[conditionType]
                              }}</ion-select-option
                            >
                          </ion-select>
                          <ion-chip
                            *ngIf="CONDITIONS[condition.field].searchType"
                            mode="ios"
                            class="select-chip select-outline"
                            [outline]="true"
                            (click)="showSearchOptions(condition)"
                            [disabled]="isLoading"
                            style="width: 38%"
                          >
                            <ion-label>
                              <!-- Remove this when we support multiple types of condition values -->
                              <ion-icon name="pricetag"></ion-icon>
                              {{
                                lookups[condition.field]?.[condition.value] ??
                                  "Select an option..."
                              }}
                            </ion-label>
                          </ion-chip>
                          <ion-input
                            *ngIf="!CONDITIONS[condition.field].searchType"
                            [(ngModel)]="condition.value"
                            [disabled]="isLoading"
                            style="width: 38%"
                            class="input-field"
                            placeholder="Enter text here..."
                          ></ion-input>
                        </div>
                      </div>
                    </ion-list>

                    <div *ngIf="conversationCreationConditions?.length">
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin: 2px 0 12px 0;
                        "
                      >
                        <ion-button
                          fill="clear"
                          (click)="addConditionalRule()"
                          class="btn-small"
                        >
                          <ion-icon
                            name="add-outline"
                            class="padded-icon"
                          ></ion-icon>
                          Add condition
                        </ion-button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ion-list>
          </ion-card>
        </ion-col>

        <ion-col size="12" *ngIf="customer.type === CHANNEL_TYPES.SLACK">
          <ion-card class="outline-card">
            <ion-card-title class="card-title flex-space-between">
              <h3>
                In-Channel Ticket Tracker
                <a
                  href="https://docs.unthread.io/engagement/in-channel-ticket-tracker"
                  target="_blank"
                  style="margin-left: 3px"
                >
                  <ion-icon name="book-outline"></ion-icon>
                </a>
              </h3>
              <div style="margin-top: 8px">
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="customerViewEnabled"
                  class="select-outline card-accessory-select"
                  [compareWith]="genericCompareFn"
                >
                  <ion-select-option [value]="null">
                    Default ({{ customerViewEnabledDefaultLabel() }})
                  </ion-select-option>
                  <ion-select-option [value]="false">
                    Disabled
                  </ion-select-option>
                  <ion-select-option [value]="true">
                    Enabled
                  </ion-select-option>
                </ion-select>
              </div>
            </ion-card-title>

            <ion-list
              [hidden]="
                customerViewEnabled === false ||
                (authService.tenant.customerViewEnabled === false &&
                  !customerViewEnabled)
              "
            >
              <ion-item *ngIf="customerViewSettings">
                <ion-icon
                  name="finger-print-outline"
                  slot="start"
                  style="margin-right: 15px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Private Mode</h3>
                  <p>
                    Users will only be able to see their own outstanding tickets
                  </p>
                  <p>
                    Ticket details will be continued through an Unthread Bot DM
                  </p>
                </ion-label>
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="customerViewSettings.isPrivate"
                  class="select-outline"
                  [compareWith]="genericCompareFn"
                >
                  <ion-select-option [value]="null">
                    Default ({{ isCustomerViewPrivateDefaultLabel() }})
                  </ion-select-option>
                  <ion-select-option [value]="false">
                    Disabled
                  </ion-select-option>
                  <ion-select-option [value]="true">
                    Enabled
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item *ngIf="customerViewSettings">
                <ion-icon
                  name="pin-outline"
                  slot="start"
                  style="margin-right: 15px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Pin to Bottom</h3>
                  <p>Pins the ticket tracker to the bottom of the channel</p>
                </ion-label>
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="customerViewSettings.isPinnedToBottom"
                  class="select-outline"
                  [compareWith]="genericCompareFn"
                >
                  <ion-select-option [value]="null">
                    Default ({{ isCustomerViewPinnedToBottomDefaultLabel() }})
                  </ion-select-option>
                  <ion-select-option [value]="false">
                    Disabled
                  </ion-select-option>
                  <ion-select-option [value]="true">
                    Enabled
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item
                *ngIf="
                  customerViewSettings &&
                  !(
                    customerViewSettings.isPrivate ??
                    authService.tenant.customerViewSettings?.isPrivate ??
                    false
                  )
                "
              >
                <ion-icon
                  name="radio-outline"
                  slot="start"
                  style="margin-right: 15px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Include Count</h3>
                  <p>
                    Shows the number of open support requests in the pinned
                    message
                  </p>
                </ion-label>
                <ion-select
                  slot="end"
                  interface="popover"
                  [(ngModel)]="customerViewSettings.includeCount"
                  class="select-outline"
                  [compareWith]="genericCompareFn"
                >
                  <ion-select-option [value]="null">
                    Default ({{ isCustomerViewIncludeCountDefaultLabel() }})
                  </ion-select-option>
                  <ion-select-option [value]="false">
                    Disabled
                  </ion-select-option>
                  <ion-select-option [value]="true">
                    Enabled
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item *ngIf="customerViewSettings">
                <ion-icon
                  name="chatbox-ellipses-outline"
                  slot="start"
                  style="margin-right: 15px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Custom Message</h3>
                  <p>
                    Add custom text to appear in the pinned message (optional)
                  </p>
                </ion-label>
                <label class="switch" slot="end">
                  <input
                    type="checkbox"
                    [(ngModel)]="overrideDefaultCustomerViewMessage"
                    (change)="onMessageOverrideChange()"
                  />
                  <span class="slider"></span>
                </label>
              </ion-item>
              <div
                class="text-editor-container"
                *ngIf="overrideDefaultCustomerViewMessage"
              >
                <app-slack-text-editor
                  [content]="customTokens['CUSTOMER_VIEW_CUSTOM_MESSAGE']"
                  placeholder="Your custom message here..."
                  style="width: 100%"
                  [hideStrikethrough]="true"
                  [hideCodeblock]="true"
                  [hideCode]="true"
                  [hideVariable]="true"
                  (contentDidChange)="onMessageContentChange($event)"
                  [projectId]="project?.id ?? undefined"
                >
                </app-slack-text-editor>
              </div>
              <ion-item *ngIf="customerViewSettings">
                <ion-icon
                  name="terminal-outline"
                  style="margin-right: 15px"
                  slot="start"
                ></ion-icon>
                <ion-label text-wrap style="max-width: 280px">
                  <h3>Custom Modal Title (Optional)</h3>
                  <p>
                    Customize the title of the modal that appears when a user
                    submits a new ticket.
                  </p>
                </ion-label>
                <ion-input
                  slot="end"
                  class="full-width-input"
                  [(ngModel)]="customTokens['CREATE_CONVERSATION_MODAL_TITLE']"
                  placeholder="Default: Create Conversation"
                  maxlength="25"
                  *ngIf="customerViewSettings"
                ></ion-input>
              </ion-item>
              <ion-item *ngIf="customerViewSettings">
                <ion-icon
                  name="document-text-outline"
                  style="margin-right: 15px"
                  slot="start"
                ></ion-icon>
                <ion-label text-wrap style="max-width: 280px">
                  <h3>Custom Modal Subtitle (Optional)</h3>
                  <p>
                    Add additional context below the title in the ticket
                    submission modal.
                  </p>
                </ion-label>
                <ion-textarea
                  slot="end"
                  class="full-width-input"
                  [(ngModel)]="
                    customTokens['CREATE_CONVERSATION_MODAL_SUBTITLE']
                  "
                  placeholder="Default: Fill out ticket details below"
                  maxlength="200"
                  rows="2"
                  *ngIf="customerViewSettings"
                ></ion-textarea>
              </ion-item>
              <ion-item *ngIf="customerViewSettings">
                <ion-icon
                  name="pricetag-outline"
                  style="margin-right: 15px"
                  slot="start"
                ></ion-icon>
                <ion-label text-wrap style="max-width: 280px">
                  <h3>Ticket Type Label (Optional)</h3>
                  <p>
                    Customize the label for the ticket type selector in the
                    conversation creation modal.
                  </p>
                </ion-label>
                <ion-input
                  slot="end"
                  class="full-width-input"
                  [(ngModel)]="customTokens['TICKET_TYPE_LABEL']"
                  placeholder="Default: Ticket type"
                  maxlength="75"
                  *ngIf="customerViewSettings"
                ></ion-input>
              </ion-item>
              <ion-item *ngIf="customerViewSettings">
                <ion-icon
                  name="pricetag-outline"
                  style="margin-right: 15px"
                  slot="start"
                ></ion-icon>
                <ion-label text-wrap style="max-width: 280px">
                  <h3>Ticket Type Placeholder (Optional)</h3>
                  <p>
                    Customize the placeholder for the ticket type selector in
                    the conversation creation modal.
                  </p>
                </ion-label>
                <ion-input
                  slot="end"
                  class="full-width-input"
                  [(ngModel)]="customTokens['TICKET_TYPE_PLACEHOLDER']"
                  placeholder="Default: Select a ticket type"
                  maxlength="75"
                  *ngIf="customerViewSettings"
                ></ion-input>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar class="constrained-content">
    <div class="flex-space-between">
      <ion-button
        color="success"
        (click)="save()"
        [disabled]="isLoading"
        style="margin-left: 20px"
        >Save changes
      </ion-button>
      <ion-button
        color="danger"
        fill="clear"
        (click)="delete()"
        [disabled]="isLoading"
      >
        Disconnect channel
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
